'use strict';

import breakpoints from '../config/breakpoints.js';

const selectors = {
    'hamburger': '.js-hamburger',
    'navMenuContainer': '.js-nav-container',
    'navMenu': '.js-nav-menu',
    'navCategory': '.js-nav-category',
    'menuHeaderOverlay': '.js-header-overlay',
};

const cssClasses = {
    'activeNav': 'navigation__category--open',
    'activeNavOpened': 'nav__menu__categoryIsOpen',
    'navOpened': 'nav-opened',
    'hamburgerActive': 'is-active',
    'categoryOpen': 'category--open',
    'navOverlayOpened': 'overlay--nav',
    'noSubNavCategory': 'no-sub-menu',
    'subNavCategory': 'has-sub-menu',
};

const options = {
    'animationDelay': 500,
    'resizeDelay': 500,
};

const navContainer = document.querySelector(selectors.navMenuContainer);
const menuContainer = document.querySelector(selectors.navMenu);
let menuLinks = document.querySelectorAll(selectors.navCategory);
const menuHeaderOverlay = document.querySelector(selectors.menuHeaderOverlay);
const hamburger = document.querySelector(selectors.hamburger);

function toggleHamburger() {
    hamburger.classList.toggle(cssClasses.hamburgerActive);
    document.body.classList.toggle(cssClasses.navOpened);
}

function toggleMenu(e) {
    const targetElement = e.target;

    // Skip if no sub-navigation
    if (!targetElement.parentElement.classList.contains(cssClasses.subNavCategory)) {
        return true;
    }

    this.classList.toggle(cssClasses.categoryOpen);
    navContainer.classList.toggle(cssClasses.navOpened);
    menuContainer.classList.toggle(cssClasses.activeNavOpened);
}

/**
 * @function hideSubNav
 * @description Hide sub-navigation
 * @returns {void}
 */
function hideSubNav() {
    const activeNavElements = document.querySelectorAll(`.${cssClasses.categoryOpen}`);
    activeNavElements.forEach((element) => {
        element.classList.remove(cssClasses.categoryOpen);
    });

    menuContainer.classList.remove(cssClasses.activeNavOpened);

    // Hide overlay
    if (menuHeaderOverlay) {
        menuHeaderOverlay.classList.remove(cssClasses.navOverlayOpened);
    }
}

/**
 * @function showSubNav
 * @description Show sub-navigation
 * @param {Event} e - Event
 * @returns {void}
 */
function showSubNav(e) {
    const targetElement = e.target;

    // Skip if no sub-navigation
    if (e.type === 'click' && !targetElement.parentElement.classList.contains(cssClasses.subNavCategory)) {
        return true;
    }

    if (e.type === 'click' && targetElement.parentElement.classList.contains(cssClasses.categoryOpen)) {
        return false;
    }

    if (window.innerWidth > breakpoints.maxTablet && menuHeaderOverlay) {
        // Show overlay
        menuHeaderOverlay.classList.add(cssClasses.navOverlayOpened);
    }

    document.querySelectorAll(`.${cssClasses.categoryOpen}`).forEach((element) => {
        element.classList.remove(cssClasses.categoryOpen);
    });

    targetElement.classList.add(cssClasses.categoryOpen);
    menuContainer.classList.add(cssClasses.activeNavOpened);
    e.preventDefault();
}

/**
 * @function toggleSubNav
 * @description Show/Hide desktop sub-navigation
 * @param {Event} e - Event
 * @returns {void}
 */
function toggleSubNav(e) {
    const target = (e.type === 'mouseenter') ? e.target : e.currentTarget;

    if (target.classList.contains(cssClasses.noSubNavCategory)) {
        hideSubNav();
    } else {
        showSubNav(e);
    }
}

/**
 * @function initEvents
 * @description Initialize Events
 * @returns {void}
 */
function initEvents() {
    let hoverTimeout = null;

    if (menuLinks && menuLinks.length > 0) {
        menuLinks.forEach((menuLink) => {
            menuLink.addEventListener('mouseenter', function (e) {
                hoverTimeout = setTimeout(() => toggleSubNav(e), options.animationDelay);
            });

            menuLink.addEventListener('mouseleave', function () {
                clearTimeout(hoverTimeout);
            });

            menuLink.addEventListener('click', function (e) {
                toggleSubNav(e);
            });
        });
    }

    if (menuHeaderOverlay) {
        menuHeaderOverlay.addEventListener('click', hideSubNav);
    }
}

function initMobileEvents() {
    if (hamburger) {
        hamburger.addEventListener('click', toggleHamburger);
    }

    if (menuLinks && menuLinks.length) {
        menuLinks.forEach((menuLink) => {
            menuLink.addEventListener('click', toggleMenu);
        });
    }
}

function removeEvents() {
    if (hamburger) {
        hamburger.removeEventListener('click', toggleHamburger);
    }

    if (menuLinks && menuLinks.length) {
        // // Remove all event listeners
        menuLinks.forEach((menuLink) => {
            const clone = menuLink.cloneNode(true);
            menuLink.parentNode.replaceChild(clone, menuLink);
        });
        menuLinks = document.querySelectorAll(selectors.navCategory);
    }

    if (menuHeaderOverlay) {
        menuHeaderOverlay.removeEventListener('click', hideSubNav);
    }
}

export function initNavigation() {
    if (!menuContainer) {
        return;
    }

    if (window.innerWidth > breakpoints.maxTablet) {
        initEvents();
    } else {
        initMobileEvents();
    }

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            hideSubNav();
            removeEvents();

            // Reinitialize navigation
            if (window.innerWidth > breakpoints.maxTablet) {
                initEvents();
            } else {
                initMobileEvents();
            }
        }, options.resizeDelay);
    });
}
